/**
 * Formats a string of comma-separated locations by replacing the last comma with '&' symbol.
 *
 * @param {string} str - The string to be formatted. Must be a list of locations separated by commas, no spaces.
 * @returns {string} Returns the formatted location string with the last comma replaced by '&' symbol.
 * If there is no comma in the string, the original string will be returned unchanged.
 */
export const formatLocations = (str) => {
    if (str.indexOf(',') === -1) return str;
    const parts = str?.split(',');
    const lastPart = parts.pop();
    return `${parts.join(', ')} & ${lastPart}`;
};
